export function Loader() {
  return (
    <div className="flex h-full">
      <div className="m-auto aspect-square h-20 max-h-full animate-spin rounded-full border-8 border-gray-300 border-t-slate-900" />
    </div>
  );
}
